import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER
// } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import loadingReducer from '../slices/loading/loadingSlice';
import loginReducer from '../slices/login';
import serviceReducer from '../slices/service';
import regionReducer from '../slices/region';
import provinceReducer from '../slices/province';
import municipalityReducer from '../slices/municipality';
import barangayReducer from '../slices/barangay';
import transactionReducer from '../slices/transaction';
import transactionTypeReducer from '../slices/transaction-type';
import ownershipTypeReducer from '../slices/ownership-type';
import servinceTypeReducer from '../slices/service-type';
import routeReducer from 'slices/route';
import transactionTypeRequirementReducer from '../slices/transaction-type-requirement';
import applicationReducer from '../slices/application';
import paymentReducer from '../slices/payment';
import appointmentReducer from '../slices/appointment';
import branchReducer from '../slices/branch';
import { reduxBatch }  from '@manaflair/redux-batch';

import Cookie from 'js-cookie';

const isAuthenticated = !!Cookie.get('ltfrb-site:token') 

// const persistConfig = {
//   key: 'root',
//   version: 1,
//   storage,
//   whitelist: ['auth' ,'transaction', 'transactionType', 'ownershipType', 'serviceType']
// }

const rootReducer = combineReducers({
  loading: loadingReducer,
  auth: loginReducer,
  service: serviceReducer,
  region: regionReducer,
  province: provinceReducer,
  municipality: municipalityReducer,
  barangay: barangayReducer,
  transaction: transactionReducer,
  transactionType: transactionTypeReducer,
  ownershipType: ownershipTypeReducer,
  serviceType: servinceTypeReducer,
  route: routeReducer,
  transactionTypeRequirement: transactionTypeRequirementReducer,
  application: applicationReducer,
  payment: paymentReducer,
  appointment: appointmentReducer,
  branch: branchReducer
})

// const persistedReducer = persistReducer(persistConfig, rootReducer)
// const isAuthenticated = !!Cookie.get('ltfrb-site:token') 

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    auth: {
      isAuthenticated,
      isLoading: false
    }
  },
  // middleware: getDefaultMiddleware({
  //   serializableCheck: {
  //     ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
  //   }
  // }),
  enhancers: [reduxBatch]
});



export default store
